import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const QUEUE_OVERVIEW = gql`
  query QueueOverview {
    queueOverview {
      queues {
        name
        waiting
        active
        completed
        failed
        delayed
        paused
        isPaused
      }
      dlqs {
        name
        waiting
        active
        completed
        failed
        delayed
        paused
        isPaused
      }
      totalWaiting
      totalActive
      totalFailed
    }
  }
`;

export const QUEUE_JOBS = gql`
  query QueueJobs($input: QueueJobsInput!) {
    queueJobs(input: $input) {
      jobs {
        id
        name
        data
        status
        attemptsMade
        maxAttempts
        processedOn
        finishedOn
        failedReason
        timestamp
        delay
        progress
      }
      total
    }
  }
`;

export const QUEUE_DLQ_JOBS = gql`
  query QueueDlqJobs($queueName: String!, $limit: Int, $offset: Int) {
    queueDlqJobs(queueName: $queueName, limit: $limit, offset: $offset) {
      jobs {
        id
        name
        data
        status
        attemptsMade
        maxAttempts
        processedOn
        finishedOn
        failedReason
        timestamp
        delay
        progress
      }
      total
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const RETRY_QUEUE_JOB = gql`
  mutation RetryQueueJob($queueName: String!, $jobId: String!, $isDlq: Boolean) {
    retryQueueJob(queueName: $queueName, jobId: $jobId, isDlq: $isDlq)
  }
`;

export const REMOVE_QUEUE_JOB = gql`
  mutation RemoveQueueJob($queueName: String!, $jobId: String!, $isDlq: Boolean) {
    removeQueueJob(queueName: $queueName, jobId: $jobId, isDlq: $isDlq)
  }
`;

export const RETRY_ALL_FAILED_JOBS = gql`
  mutation RetryAllFailedJobs($queueName: String!, $isDlq: Boolean) {
    retryAllFailedJobs(queueName: $queueName, isDlq: $isDlq)
  }
`;

export const CLEAN_QUEUE_JOBS = gql`
  mutation CleanQueueJobs(
    $queueName: String!
    $status: String!
    $gracePeriodHours: Int
  ) {
    cleanQueueJobs(
      queueName: $queueName
      status: $status
      gracePeriodHours: $gracePeriodHours
    )
  }
`;

export const PROMOTE_QUEUE_JOB = gql`
  mutation PromoteQueueJob($queueName: String!, $jobId: String!) {
    promoteQueueJob(queueName: $queueName, jobId: $jobId)
  }
`;
